import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SiteFooter from '@wix/da-shared-react/pkg/SiteFooter';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import Header from '../../../Header';
import NetworkBarWrapper from '../NetworkBarWrapper';
import ScrollDependentStickyContainer from '../../../ScrollDependentStickyContainter';
import { BiEvent } from '@wix/da-bi/pkg/events';

import s from './PageContainer.scss';

export interface Props {
  title?: React.ReactNode;
  tagLine?: React.ReactNode;
  customHeader?: React.ReactNode;
  headerNavigation?: React.ReactNode;
  headerLeftSideContent?: React.ReactNode;
  headerRightSideContent?: React.ReactNode;
  headerIsStickyOnScrollUp?: boolean;
  withNavigation?: boolean;
  withNetworkBar?: boolean;
  withTabHeader?: boolean;
  isSearchPage?: boolean;
  isInfiniteScroll?: boolean;
  hasMore?: boolean;
  withFooter?: boolean;
  className?: string;
  wrapperClassName?: string;
  headerClassName?: string;
  titleClassName?: string;
  biData?: BiEvent;
  children?: React.ReactNode;
}

const PageContainer: React.FC<Props> = ({
  children,
  withTabHeader = true,
  isSearchPage,
  withFooter = false,
  className,
  title,
  tagLine,
  headerNavigation,
  headerRightSideContent,
  headerLeftSideContent,
  withNetworkBar = true,
  biData = {},
  withNavigation,
  wrapperClassName,
  headerClassName,
  titleClassName,
  customHeader,
  headerIsStickyOnScrollUp,
}) => {
  const isMobile = useContext(MobileContext);

  return (
    <NetworkBarWrapper
      isNetworkBarEnabled={withNetworkBar}
      className={classnames(
        s['root'],
        wrapperClassName,
        !withFooter && !withNetworkBar && s['no-footer-page']
      )}
    >
      <BiLoggerContextProvider value={{ ...biData }}>
        {headerIsStickyOnScrollUp && (
          <ScrollDependentStickyContainer className={s['scroll-sticky']}>
            {customHeader}
            {withTabHeader && (
              <Header
                title={title}
                tagline={tagLine}
                rightSideContent={headerRightSideContent}
                leftSideContent={headerLeftSideContent}
                className={classnames(headerClassName, s['header'])}
                withNavigation={withNavigation}
                titleClassName={titleClassName}
                isSticky={false}
              >
                {headerNavigation}
              </Header>
            )}
          </ScrollDependentStickyContainer>
        )}
        {!headerIsStickyOnScrollUp && (
          <>
            {customHeader}
            {withTabHeader && (
              <Header
                title={title}
                tagline={tagLine}
                rightSideContent={headerRightSideContent}
                leftSideContent={headerLeftSideContent}
                className={s['header']}
                withNavigation={withNavigation}
                titleClassName={titleClassName}
                isSticky={
                  headerIsStickyOnScrollUp ?? (!isMobile || withNavigation)
                }
              >
                {headerNavigation}
              </Header>
            )}
          </>
        )}
        <div
          className={classnames(
            s['page'],
            isSearchPage && s['search'],
            withTabHeader && s['with-header']
          )}
        >
          <div className={className}>{children}</div>
        </div>
      </BiLoggerContextProvider>
      {withFooter && <SiteFooter />}
    </NetworkBarWrapper>
  );
};
PageContainer.displayName = 'PageContainer';

export default PageContainer;
